import { UnitAccessData } from 'src/lib/fliko/models/users/access.data';
import { UnitAccessVM } from 'src/app/view/user-context/services/models/estateUser.data';
import { LocalizationService } from '../services/localization.service';

export class ViewModelHelper {
  public static unitAccessToVM(obj: UnitAccessData, estateId: string, ls: LocalizationService): UnitAccessVM {
    return { ...obj, estateId, residentName: obj.name ?? ls.translate('label.noName') };
  }
}
